module.exports = __webpack_public_path__ + "static/media/hamburger.7eb7dd6a.svg";